import React from "react";
import "./LogTRNUsageScreen.css";
import { useEffect, useState } from "react"
import { GetAll } from "../../Services/LogApiService";
import { Col, Input, Modal, Row, Table, Tooltip,DatePicker,Select,Button   } from "antd";
import type { ColumnsType , TablePaginationConfig } from "antd/lib/table";
import dayjs from "dayjs";    
import moment, { Moment } from "moment"; 
import { ButtonComponents } from "../../components/ButtonComponents/ButtonComponents";
import useAlert from "../../hooks/useAlert";
import {
    SearchOutlined,
} from "@ant-design/icons";
import useLoading from "../../hooks/useLoading";
const { Option } = Select;
const PAGE_SIZE = 10;
const SEND_FMT = "YYYY-MM-DD HH:mm:ss";

    const LogTRNUsageScreen = () => {
    const [pageNumber, setPageNumber] = useState(1);
    const [logData, setLogData] = useState<any[]>([]);
    const [total, setTotal] = useState(0);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [processType, setProcessType] = useState<string | undefined>(undefined);
    const [dateRange, setDateRange] = useState<[Moment | null, Moment | null]>([null, null]); 
    const { setLoad } = useLoading();
    const { toggleAlert } = useAlert();

    const processTypes = ["LOGIN", "LOGOUT", "CREATE", "UPDATE", "DELETE"];

    // ค้นหา/เปลี่ยนช่วงวัน → กลับหน้า 1
    useEffect(() => { setPageNumber(1); }, [searchKeyword,processType, dateRange]);

    useEffect(() => {
        fetchGetAll();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageNumber]);

    async function fetchGetAll() {
        try {
        setLoad(true);

        const [start, end] = dateRange;
        const requestBody = {
            PageNumber: pageNumber,
            PageSize: PAGE_SIZE,
            SearchKeyword: searchKeyword,
            StrDate: start ? start.startOf("day").format("YYYY-MM-DD HH:mm:ss") : "",
            EndDate: end ? end.endOf("day").format("YYYY-MM-DD HH:mm:ss") : "",
            ProcessType: processType ?? "",
        };

        const result = await GetAll(requestBody);
        const rows = result?.Logs ?? result?.logs ?? [];
        const totalCount = result?.total ?? 0;

        setLogData(rows);
        setTotal(totalCount);
        } catch (e: any) {
        } finally {
            setLoad(false);
        }
    }

        const handleSearchClick = () => {
        setPageNumber(1);
        if (pageNumber === 1) {
        fetchGetAll();
        }
    };

    const handleResetClick = () => {
        setSearchKeyword("");
        setProcessType(undefined);
        setDateRange([null, null]);
        setPageNumber(1);
        if (pageNumber === 1) {
        fetchGetAll();
        }
    };


    const columns: ColumnsType<any> = [
        {
        title: () => <b>ActionDate</b>,
        key: "ActionDate",
        dataIndex: "ActionDate",
        width: 200,
        render: (value: string | number | Date | dayjs.Dayjs | null | undefined) =>
            value ? dayjs(value).format("DD MMM YYYY HH:mm:ss") : "-",
        },
        { title: () => <b>ActorId</b>, key: "ActorId", dataIndex: "ActorId", width: 120 },
        { title: () => <b>ActorNameTh</b>, key: "ActorNameTh", dataIndex: "ActorNameTh", width: 200 },
        { title: () => <b>ActorNameEn</b>, key: "ActorNameEn", dataIndex: "ActorNameEn", width: 200 },
        { title: () => <b>ActionProcess</b>, key: "ActionProcess", dataIndex: "ActionProcess", width: 120 },
        { title: () => <b>ActionStatus</b>, key: "ActionStatus", dataIndex: "ActionStatus", width: 100 },
        { title: () => <b>Detail</b>, key: "Note01", dataIndex: "Note01", width: 250 },
        { title: () => <b>IPAddress</b>, key: "IPAddress", dataIndex: "IPAddress", width: 100 },
        { title: () => <b>Platform</b>, key: "Platform", dataIndex: "Platform", width: 100 },
    ];

    const handleTableChange = (p: TablePaginationConfig) => {
        setPageNumber(p.current ?? 1);
    };

    return (
        <div style={{ margin: 20 }}>
        <Row gutter={[16, 16]} align="middle">
            <Col>
            <Input
                prefix={<SearchOutlined rev={undefined} />}
                placeholder="ค้นหา"
                style={{ width: 280, borderRadius: 10 }}
                allowClear
                onChange={(e) => setSearchKeyword(e.target.value)}
            />
            </Col>
            <Col>
            <DatePicker.RangePicker
                allowEmpty={[true, true]}
                allowClear
                value={dateRange}
                format="DD/MM/YYYY"
                onChange={(vals) => setDateRange([vals?.[0] ?? null, vals?.[1] ?? null])}
            />
            </Col>

            <Col>
                <Select
                placeholder="เลือก Process Type"
                allowClear
                style={{ width: 400 }}
                value={processType}
                onChange={(val) => setProcessType(val)}
                >
                <Option value="Login">Login</Option>
                <Option value="PDF">PDF</Option>
                <Option value="View">View</Option>
                <Option value="submit">Submit</Option>
                <Option value="approve">Approve</Option>
                <Option value="rework">Rework</Option>
                <Option value="reject">Reject</Option>
                <Option value="View">View</Option>
                <Option value="Template">Template</Option>
                <Option value="Employee">Employee</Option>
                <Option value="Department">Department</Option>
                <Option value="Position">Position</Option>
                <Option value="MasterData">MasterData</Option>
                </Select>
            </Col>

            <Col>
                <Button type="primary" onClick={handleSearchClick}>
                    ค้นหา
                </Button>
            </Col>
        </Row>

        <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
            <Col xs={24}>
            <Table
                rowKey="UsageLogId"
                bordered
                columns={columns}
                dataSource={logData}
                pagination={{
                current: pageNumber,
                total: total,
                pageSize: PAGE_SIZE,
                showSizeChanger: false,
                }}
                onChange={handleTableChange}
                scroll={{ y: 1500 }}
            />
            </Col>
        </Row>
        </div>
    );
    };

export default LogTRNUsageScreen;